import React, { Component } from 'react';
import PropTypes from 'prop-types';
import s from './BulkChangeConfigurator.module.scss';
import SelectFieldEditor from '../select-field-editor/SelectFieldEditor.jsx';

const OPTIONS = [
    { label: 'Restricted access required', value: 'Inside' },
    { label: 'Restricted access not required', value: 'Outside' },
];

export default class BulkSecurityEditor extends Component {
    static propTypes = {
        value: PropTypes.string,
        onChange: PropTypes.func,
        changeType: PropTypes.string,
    };

    renderEditor = () => {
        const { value, onChange } = this.props;
        return (
            <div>
                <div className={s.dividerWithText}>With the following...</div>
                <SelectFieldEditor options={OPTIONS} selectedValue={value} onValueSelected={onChange} />
            </div>
        );
    };

    render() {
        const { changeType } = this.props;
        return changeType === 'SECURITY_CHANGE' ? this.renderEditor() : null;
    }
}
